import * as aggregate from './aggregate';
import * as binary_to_text from './binary-to-text';
import * as text_to_binary from './text-to-binary';
import * as code from './code';
import * as compare_datasets from './compare-datasets';
import * as convert_to_html from './convert-to-html';
import * as crypto from './crypto';
import * as datetime from './datetime';
import * as edit_fields from './edit-fields';
import * as filter from './filter';
import * as functionNode from './function';
import * as json from './json';
import * as json_to_csv from './json-to-csv';
import * as csv_to_json from './csv-to-json';
import * as limit from './limit';
import * as no_op from './no-op';
import * as remove_duplicates from './remove-duplicates';
import * as set from './set';
import * as sort from './sort';
import * as split_in_batches from './split-in-batches';
import * as stop_execution from './stop-execution';
import * as string from './string';
import * as summarise from './summarise';
import * as transform from './transform';
import * as wait from './wait';
import * as xml from './xml';

export const utilitiesNodes = {
  'aggregate': aggregate,
  'binary-to-text': binary_to_text,
  'text-to-binary': text_to_binary,
  'code': code,
  'compare-datasets': compare_datasets,
  'convert-to-html': convert_to_html,
  'crypto': crypto,
  'datetime': datetime,
  'edit-fields': edit_fields,
  'filter': filter,
  'function': functionNode,
  'json': json,
  'json-to-csv': json_to_csv,
  'csv-to-json': csv_to_json,
  'limit': limit,
  'no-op': no_op,
  'remove-duplicates': remove_duplicates,
  'set': set,
  'sort': sort,
  'split-in-batches': split_in_batches,
  'stop-execution': stop_execution,
  'string': string,
  'summarise': summarise,
  'transform': transform,
  'wait': wait,
  'xml': xml,
};
